import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RequirePermission } from "@/components/universal/require-permission";
import NotFoundPage from "@/catchall";

export const Route = createFileRoute("/_private/_practice-360")({
  component: PracticeLayout,
});

function PracticeLayout() {
  return (
    <RequirePermission permission="practice_360" fallback={<NotFoundPage />}>
      <Outlet />
    </RequirePermission>
  );
}
